import { authClient, API } from "../index";

// Respuestas de la encuesta de una sesión
export const getSurveyResponsesBySession = (sessionId) => {
	return authClient().get(`${API}/survey/session/${sessionId}/responses`);
};

// Eliminar una respuesta
export const deleteSurveyResponse = (id) => {
	return authClient().delete(`${API}/survey/response/${id}`);
};
